import { render, staticRenderFns } from "./UpdateProductModal.vue?vue&type=template&id=3fa04b4e&scoped=true&"
import script from "./UpdateProductModal.vue?vue&type=script&lang=js&"
export * from "./UpdateProductModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProductModal.vue?vue&type=style&index=0&id=3fa04b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa04b4e",
  null
  
)

export default component.exports